export const API_SOCKET_SERVER_URL = 'https://api.basebitmatrix.com/';
export const DB_SOCKET_SERVER_URL = 'https://db.basebitmatrix.com/';
